import React from 'react';
import PropTypes from 'prop-types';
import {Skeleton} from "@material-ui/lab";

const MenuComponent = props => {
    const {component: {properties: {mode} = {}} = {}} = props;
    return (
        mode === 'horizontal' ? (
            <HorizontalMenu/>
        ) : (
            <VerticalMenu/>
        )
    );
};

MenuComponent.propTypes = {
    component: PropTypes.object
};

export default MenuComponent;


const HorizontalMenu = () => {
    return(
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
            <Skeleton style={{width: 50}} animation={false}/>
            <Skeleton style={{width: 50, marginLeft: 5}} animation={false}/>
            <Skeleton style={{width: 50, marginLeft: 5}} animation={false}/>
        </div>
    )
}
const VerticalMenu = () => {
    return(
        <div style={{display: 'flex', flexDirection: 'column', padding: '0 5px'}}>
            <Skeleton animation={false} style={{padding: '7px 0'}}/>
            <Skeleton animation={false} style={{padding: '7px 0'}}/>
            <Skeleton animation={false} style={{padding: '7px 0'}}/>
        </div>
    )
}